import { useState, useEffect, forwardRef } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useDispatch, useSelector } from "react-redux";
import { hideNotification } from "../app/slices/notificationSlice";

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function NotificationSnackbar() {
  const dispatch = useDispatch();
  const notification = useSelector((state) => state.notification.data);
  const [open, setOpen] = useState(false);

  // `notification.id` is in the deps so a second notification re-opens the
  // snackbar even though `show` was already true — without it the message
  // swaps in but MUI's auto-hide timer keeps running from the first one and
  // the new message can disappear almost immediately.
  useEffect(() => {
    setOpen(notification.show);
  }, [notification.show, notification.id]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(hideNotification(notification));
  };

  return (
    <Snackbar
      // Remounting per notification restarts the auto-hide timer.
      key={notification.id}
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{
        horizontal: "right",
        vertical: "top",
      }}
    >
      <Alert
        onClose={handleClose}
        severity={notification.type}
        sx={{ width: "100%" }}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
}
